import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Instrument } from '@prlw/core/monitor/instrument.entity';

@Component({
  selector: 'prlw-pin-basis-details-button-ui',
  templateUrl: './pin-basis-details-button.component.html',
  styleUrls: ['./pin-basis-details-button.component.scss'],
})
export default class PinBasisDetailsButtonComponent {
  @Input() instrument!: Instrument;
  @Input() unpinned: boolean = true;
  @Output() pinEvents = new EventEmitter<Instrument>();

  pin() {
    this.pinEvents.emit(this.instrument);
  }

  unpin() {
    this.pinEvents.emit();
  }
}
